var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosewhitebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4891 3.5114C15.8069 -1.16981 8.19233 -1.16981 3.51013 3.5114C-1.17004 8.19261 -1.17004 15.8091 3.51013 20.4904C5.85123 22.8305 8.92566 24 12.0001 24C15.0746 24 18.148 22.8304 20.4891 20.4904C25.1703 15.8092 25.1703 8.19261 20.4891 3.5114ZM16.9514 15.538C17.3426 15.9292 17.3426 16.5615 16.9514 16.9527C16.7563 17.1478 16.5002 17.2458 16.2441 17.2458C15.988 17.2458 15.7318 17.1478 15.5367 16.9527L12.0001 13.415L8.46442 16.9516C8.26835 17.1467 8.0122 17.2448 7.75708 17.2448C7.50097 17.2448 7.24482 17.1467 7.04973 16.9516C6.65856 16.5605 6.65856 15.9272 7.04973 15.537L10.5854 12.0004L7.04874 8.46372C6.65758 8.07255 6.65758 7.43925 7.04874 7.04907C7.43893 6.6579 8.07222 6.6579 8.46339 7.04907L12 10.5857L15.5367 7.04907C15.9278 6.6579 16.5602 6.6579 16.9513 7.04907C17.3425 7.43925 17.3425 8.07255 16.9513 8.46372L13.4147 12.0004L16.9514 15.538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosewhitebg);
export default __webpack_public_path__ + "static/media/closewhitebg.aa0933a7445e14b580aba18215ad5462.svg";
export { ForwardRef as ReactComponent };